import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Cache, CacheType } from '../presentation/delegates';

@Injectable()
export class CacheService implements Cache {
    update = new Subject<CacheType>();
}
